/**
 * features/pos/components/OfflinePendingGuardModal.tsx
 *
 * P0-1 · Fase 8G — Aviso antes de logout / cambio de contexto cuando existen
 * intenciones offline pendientes (draft/queued/syncing/conflict). NO borra la
 * cola, NO la reatribuye. Solo advierte y deja decidir.
 */

import { AlertTriangle } from 'lucide-react'

interface OfflinePendingGuardModalProps {
  count: number
  storeLabel: string
  title: string
  message: string
  reviewHref?: string
  confirmLabel: string
  onReview: () => void
  onConfirm: () => void
}

export function OfflinePendingGuardModal({
  count,
  storeLabel,
  title,
  message,
  confirmLabel,
  onReview,
  onConfirm,
}: OfflinePendingGuardModalProps) {
  return (
    <div className="fixed inset-0 z-[340] flex items-center justify-center bg-black/70 p-4">
      <div className="w-full max-w-sm bg-white rounded-2xl shadow-2xl p-6 space-y-4 text-center">
        <span className="inline-flex items-center justify-center w-12 h-12 rounded-2xl bg-amber-50 text-amber-600 mx-auto">
          <AlertTriangle className="w-6 h-6" />
        </span>
        <h2 className="font-black text-[17px] text-navy-900">{title}</h2>
        <p className="text-navy-500 text-[13px]">{message}</p>
        <div className="bg-navy-50 rounded-xl px-4 py-2 text-[13px] text-navy-700">
          <b>{count}</b> operación(es) pendiente(s) · Tienda <b>{storeLabel}</b>
        </div>
        <div className="flex gap-2">
          <button
            onClick={onReview}
            className="flex-1 h-11 rounded-xl border-2 border-surface-200 text-surface-600 font-semibold text-[14px]"
          >
            Volver y revisar
          </button>
          <button
            onClick={onConfirm}
            className="flex-1 h-11 rounded-xl bg-brand-primary-deep text-brand-on-primary font-black text-[14px] ring-1 ring-inset ring-white/10 hover:bg-brand-primary"
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  )
}
